import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import api from '../api';
import { 
  FETCH_NEW_INTERVENTIONS_DOCTORS, 
  ON_SAVE_INTERVENTIONS
} from 'constants/ActionTypes';
import { userSignOut } from 'actions/Auth';
import { showNewInterventionsLoader, showNewInterventionsMessage, fetchDoctorsSuccess, showNewInterventionsSaveLoader } from '../actions/NewInterventions';

function* getDoctors() {
  try {
    yield put(showNewInterventionsLoader());
    const authToken = localStorage.getItem('token');
    const doctors = yield call(api.interventionsApi.getDoctors, { authToken });

    if (doctors.errorMessage) {
      yield put(showNewInterventionsMessage(doctors.errorMessage, true));
    } else {
      yield put(fetchDoctorsSuccess(doctors));
    }
  } catch (error) {
    yield put(showNewInterventionsMessage(error.message || error, true));
    yield put(userSignOut());
  }
}

function* onSaveNewInterventions({payload}) {
  try {
    yield put(showNewInterventionsSaveLoader());
    const authToken = localStorage.getItem('token');
    const nterventions = yield call(api.interventionsApi.createInterventions, { payload, authToken });

    if (nterventions.errorMessage) {
      yield put(showNewInterventionsMessage(nterventions.errorMessage, true));
    } else {
      yield put(showNewInterventionsMessage('review.newReviewHasBeenAdded'));
    }
  } catch (error) {
    yield put(showNewInterventionsMessage(error.message || error, true));
    yield put(userSignOut());
  }
}


export function* fetchDoctors() {
  yield takeEvery(FETCH_NEW_INTERVENTIONS_DOCTORS, getDoctors);
}

export function* createInterventions() {
  yield takeEvery(ON_SAVE_INTERVENTIONS, onSaveNewInterventions);
}

export default function* rootSaga() {
  yield all([
    fork(fetchDoctors),
    fork(createInterventions)
  ]);
}



// WEBPACK FOOTER //
// ./sagas/NewInterventions.js